import { getAffirmConfig } from './affirmConfig';

let affirmReadyPromise = null;
let affirmInstance = null;

// Non-null once Affirm.js has finished initialising.
export const getLoadedAffirm = () => affirmInstance;

export const loadAffirm = (sessionDetails) => {
  if (affirmReadyPromise) return affirmReadyPromise;

  const { publicApiKey, scriptUrl } = getAffirmConfig(sessionDetails);
  if (!publicApiKey) {
    return Promise.reject(new Error('Affirm public API key is missing'));
  }

  affirmReadyPromise = new Promise((resolve, reject) => {
    window._affirm_config = { public_api_key: publicApiKey, script: scriptUrl };

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;

    script.onload = () => {
      if (!window.affirm?.ui?.ready) {
        affirmReadyPromise = null; // allow a later retry
        reject(new Error('Affirm.js loaded but the SDK is unavailable'));
        return;
      }
      window.affirm.ui.ready(() => {
        affirmInstance = window.affirm;
        resolve(window.affirm);
      });
    };

    script.onerror = () => {
      affirmReadyPromise = null; // allow a later retry
      reject(new Error('Failed to load Affirm.js'));
    };

    document.body.appendChild(script);
  });

  return affirmReadyPromise;
};
